<template>
  <v-data-table
    :headers="headers"
    :items="tableData"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalCount"
    :item-class="itemRowBackground"
    >
    <template v-slot:item.created_at="{item}">
        <v-chip
          dark
          small
          :color="getServiceLevelColor(item.serviceLevel)"
        >{{ item.serviceLevel }} day(s)</v-chip>
    </template>
    <template v-slot:item.actions="{item}">
        <v-btn icon @click="open(item.id)">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
        <v-btn v-if="item.status_id=='new' || item.status_id=='backordered'" icon @click="togglePickWave(item)">
          <v-icon>{{buildInPickwave.find(b => b.id == item.id) ? 'mdi-cart-off' : 'mdi-cart'}}</v-icon>
        </v-btn>
    </template>
    <template v-slot:item.buildStatus="{item}">
        {{(item.prescription)?item.prescription.statusId:'Not a prescription'}}
    </template>

    <template v-slot:item.pickability="{item}">
      <v-chip
        dark
        small
        :color="getPickabilityColor(item.pickability)"
        >{{ getPickabilityLabel(item.pickability) }}</v-chip>
      
    </template>
    
  </v-data-table>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from 'vuex';
import hasQueryParams from '../../mixins/hasQueryParams.vue';
export default {
  name: 'BuildTable',
  mixins: [hasQueryParams],
  data() {
    return {
      tableData: [],
      totalCount: 0,
      loading: null,
      options: { sortBy:['created_at'], sortDesc:[true],rowsPerPage: 15 },
      queryFields: ['page', 'itemsPerPage', 'sortBy', 'sortDesc']
    };
  },
  props: {
    status: {
      type: String
    },
    pickable: {
      type: Boolean,
      default: () => null
    }
  },
  computed:{
    ...mapGetters("pickwave", ["buildInPickwave"]),
    headers () {
      return [
        ... this.status =='pending' ? [{text: "PendingBox", value: "pendingBox.name", sortable:false}] : [],
        {text: "Order Id", value: "order_id", align:"right"},
        //{text: "Invoice", value: "order.invoice.invoiceNumber", align: "right", sortable:false },
        {text: "Customer", value: "client.displayName", sortable:false },
        {text: "Shop", value: "shop.name", sortable:false},
        {text: "Status", value: "status_id", bgcolor: null,sortable:false },
        {text: "Club Fitter", value: "clubFitter.displayName", bgcolor: null,sortable:false },
        {text: "Builder", value: "builder.displayName", bgcolor: null,sortable:false },
        {text: "Service Level", value: "created_at"},
        ... this.status =='new' || this.status == 'backordered' ? [{text: "Pickability", value: "pickability", sortable:false}] : [],
        {text: "Actions", value: "actions", sortable:false}
      ]
    },
    query () {
      return {
        page: this.options.page.toString(),
        itemsPerPage: this.options.itemsPerPage.toString(),
        sortBy: this.options.sortBy.toString(),
        sortDesc: this.options.sortDesc.toString()
      }
    }
  },
  mounted: function() {
    this.parseQuery();
    this.getBuilds();
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getBuilds();
      }, 100)
    }
  },
  methods: {
    ...mapActions("build",["list"]),
    ...mapActions("pickwave",["togglePickWave"]),
    getBuilds() {
      this.loading = true;
      this.pushNewRoute()

      this.list({
          pagination: this.options,
          rows_per_page: this.options.rowsPerPage,
          search: this.search,
          filters: {
            status_id:this.status,
            pickable:this.pickable
          },
          expand: "prescription"
        })
        .then(data => {
          this.tableData = data.builds.data;
          this.totalCount = data.builds.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(id) {
      this.$router.push("/build/build/" + id);
    },
    itemRowBackground(item) {
      return this.buildInPickwave.find(b => b.id == item.id) ? 'grey lighten-1' : ''
    },
    getServiceLevelColor(sl) {
      if (sl > 20) {
        return "red";
      }
      if (sl > 10) {
        return "orange";
      }
      if (sl > 0) {
        return "green";
      }
    },
    getPickabilityColor(p) {
      if (p == "FULLY_PICKABLE") {
        return "green";
      }
      if (p == "PARTIALLY_PICKABLE") {
        return "orange";
      }
      if (p == "NOT_PICKABLE") {
        return "red";
      }
    },
    getPickabilityLabel(p) {
      if (p == "FULLY_PICKABLE") {
        return "Fully Pickable";
      }
      if (p == "PARTIALLY_PICKABLE") {
        return "Partially Pickable";
      }
      if (p == "NOT_PICKABLE") {
        return "Not Pickable";
      }
    },
    parseQuery(){
      this.options = {
        ...this.options,
        page: this.$route.query.page ? parseInt(this.$route.query.page): 1,
        itemsPerPage: this.$route.query.itemsPerPage ? parseInt(this.$route.query.itemsPerPage): 15,
        sortBy: [this.$route.query.sortBy ?? "order_id" ],
        sortDesc: [this.$route.query.sortDesc === 'true' ?? false]
      }
    },
  }
};
</script>
<style>

</style>